
















































import TableActionDropdown from '@/components/TableActionDropdown.vue';
import { GroupLevelAttribute } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { isDefaultCourseGLA } from '@/jbi-shared/util/group-level-attributes.util';
import { capitalize } from '@/jbi-shared/util/string.utils';
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({
  components: {
    TableActionDropdown
  }
})
export default class CourseAttributeRow extends Vue {
  @Prop() courseAttribute!: GroupLevelAttribute;
  @Prop({ type: Boolean, default: false }) isDefaultCourseGLA!: boolean;

  get capitalizedType() {
    return capitalize(this.courseAttribute.groupLevelAttributeType.type);
  }

  @Emit('edit')
  emitEditEvent() {
    return this.courseAttribute;
  }

  @Emit('delete')
  emitDeleteEvent() {
    return this.courseAttribute;
  }
}
